<script setup>
import { getAuthor } from '~/composables/builder/api';

const props = defineProps({
    page: {
        type: Object,
        required: false,
    },
});

const { data: author, error } = await useAsyncData(`getAuthor-${props.page.data.author.id}`, () =>
    getAuthor(props.page.data.author.id)
);
</script>

<template>
    <div v-if="author" class="blog-author">
        <div class="image">
            <MessImage :src="author.data.authorImage" :alt="author.name" />
        </div>
        <div class="name-description">
            <p class="name fs-18">{{ author.name }}</p>
            <p class="description fs-16">{{ author.data.authorDescription }}</p>
        </div>
    </div>
</template>

<style lang="scss">
.blog-author {
    margin: 2.5rem auto 0 auto;
    padding: 2.5rem 0;
    max-width: 56.25rem !important;

    display: flex;
    gap: 2.375rem;
    align-items: center;
    color: var(--teal, #042729);
    border-top: 1px solid var(--cream-dark);

    @media (max-width: $mobile) {
        padding: 2rem 30px;
        gap: 1.5rem;
    }

    .image {
        width: 4.5rem;
        height: 4.5rem;
        border-radius: 0;
        overflow: hidden;
        border-radius: var(--radius);

        .mess-image {
            border-radius: var(--radius);
            overflow: hidden;
        }

        @media (max-width: $mobile) {
            width: 4rem;
            height: 4rem;
        }
    }

    .name-description {
        .name {
            font-weight: 600;
            line-height: 150%;
            /* 27px */
        }

        .description {
            font-weight: 300;
            line-height: 160%;
            /* 25.6px */
            letter-spacing: 0.48px;
        }

        @media (max-width: $mobile) {
            width: calc(100% - 4rem - 1.5rem);

            .name {
                font-size: 16px;
            }

            .description {
                font-size: 12px;
            }
        }
    }
}
</style>
